module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABBklEQVQ4T5XUW07DMBCF4a8CIQRiOdzL/c5ueGAPSN0MSLCMPsBeQDwggabYVRrZSeOXRM7k95mZMx75X6v4Se9DHxv4GmENj3jF+0DKCY7wFKBY27jDywDYGY6TgGkGNWHP+OhRdp6URBbTiG2CloVd4jAryQe2QX2wa+y3ISVF+YCo2S0m+E6bN9grQbpA8W0TnwkS0N0apA+U1d2nrs4LW2pEqUbNuCsc4LfPGl2gC4xTOiupZlWf1UALZksSdxKs6LMSKGx/WilsFdYGxdyEa7sKW4Q1QeHWcG1nd2ppZlC4NVy7DCR3dUFZgLbwgLc8gAOukoCFgPk1st4YhQGcWejs3z+a+j0bupb2qgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign/close.png
// module id = LCN6
// module chunks = 1